import { IconButton } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IcDotSpread } from '@/assets/images';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/TailwindComponents/base/Tooltip';
import { IEquipment } from '@/models';
import { equipmentTypeMap } from '@/pages/UnitType/data';

const name = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.name || '-',
});

const type = (): Partial<GridColDef> => ({
  renderCell: (params) => (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex-1 truncate cursor-default">
            {equipmentTypeMap[params.row.type] || params.row.type || '-'}
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="break-words z-[9999]">
          {equipmentTypeMap[params.row.type] || params.row.type || '-'}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  ),
});

const serialNumber = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.serialNumber || '-',
});

const manufacturer = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.manufacturer || '-',
});

const model = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.model || '-',
});

const location = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.location || '-',
});

const status = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row.status || '-',
});

const actions = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param: IEquipment,
  ) => void,
): Partial<GridColDef> => ({
  sortable: false,
  filterable: false,
  renderCell: (params) => (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        openMenu?.(e, params.row);
      }}
    >
      <IcDotSpread />
    </IconButton>
  ),
});

export const agencyEquipmentCols = (
  openMenu?: (
    event: React.MouseEvent<HTMLButtonElement>,
    param: IEquipment,
  ) => void,
) => {
  return {
    name,
    type,
    serialNumber,
    manufacturer,
    model,
    location,
    status,
    actions: () => actions(openMenu),
  };
};
